import { ComponentProps, forwardRef } from 'react'
import { Button } from '@/ui/atoms/button/Button'
import { SettingsIcon } from 'lucide-react'

export const SettingsButton = forwardRef<HTMLButtonElement, ComponentProps<typeof Button>>((props, ref) => {
  return (
    <Button
      className="h-[30px] w-[30px] rounded-full border-border bg-secondary p-0 text-secondary-foreground"
      {...props}
      ref={ref}
      prefixIcon={<SettingsIcon size={18} />}
    />
  )
})

SettingsButton.displayName = 'SettingsButton'
